import { Ayuda as AyudaComun } from '@plataforma/web/Ayuda';

/** Ayuda en Admin Lotero y Portal (arquitectura 2.12): Manual, preguntas frecuentes y Soporte. */
export function Ayuda() {
  return <AyudaComun enlaceTicket="/ayuda/tickets/nuevo" />;
}
